import { useQuery } from '@tanstack/react-query';
import { 
  getEquiposByLetrasEquipo,
  getEstadisticasEquipoById
} from '../../services/equipoEstadisticasService';

/**
 * Hook para buscar equipos por letras (búsqueda)
 * @param {string} letras - Letras para filtrar equipos
 * @param {object} options - Opciones adicionales de React Query
 */
export const useEquipoEstadisticas = (letras = '', options = {}) => {
  return useQuery({
    queryKey: ['equipoEstadisticas', letras],
    queryFn: async () => {
      const navigate = null;
      return await getEquiposByLetrasEquipo(
        letras,
        navigate
      );
    },
    enabled: letras.length > 0,
    ...options,
  });
};

/**
 * Hook para obtener estadísticas de un equipo específico por ID
 * @param {number} idTemporada - ID de la temporada
 * @param {string} idEstadisticas - ID compuesto de estadísticas (formato: codEquipo_idComp_idGrupo_idTemp)
 * @param {object} options - Opciones adicionales de React Query
 */
export const useEquipoEstadisticasById = (idTemporada, idEstadisticas, options = {}) => {
  return useQuery({
    queryKey: ['equipoEstadisticas', 'byId', idTemporada, idEstadisticas],
    queryFn: async () => {
      const navigate = null;
      return await getEstadisticasEquipoById(
        idTemporada,
        idEstadisticas,
        navigate
      );
    },
    enabled: !!(idTemporada && idEstadisticas),
    ...options,
  });
};
